import { BOX_SHADOW_TYPES } from 'mm-theme-configuration/dist/consts';
import { StyleSheet } from 'aphrodite/no-important';

type ELEVATION_TYPES_MAP = {
    [key in BOX_SHADOW_TYPES]: string
}

interface BoxShadowPropsTypes {
  boxShadowTypeNormal?: string
  boxShadowTypeHover?: string
  boxShadowTypeActive?: string
  boxShadowTypeDisable?: string
}

const elevationTypesMap:ELEVATION_TYPES_MAP = {
  LOW: '0 2px 4px 0 rgba(0,0,0,0.2)',
  HIGH: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)',
  NONE: 'unset',
};

export const getElevationType = (key:string) => elevationTypesMap[key as BOX_SHADOW_TYPES];

export const createStyleForBoxShadow = ({ boxShadowTypeNormal = 'unset', boxShadowTypeHover, boxShadowTypeActive, boxShadowTypeDisable }: BoxShadowPropsTypes) => StyleSheet.create({
  style: {
    transition: '0.2s box-shadow ease-in-out',
    willChange: 'box-shadow',
    boxShadow: boxShadowTypeNormal,
    ':hover': {
      boxShadow: boxShadowTypeHover || boxShadowTypeNormal,
    },
    ':active': {
      boxShadow: boxShadowTypeActive || boxShadowTypeNormal,
    },
    ':disabled': {
      boxShadow: boxShadowTypeDisable || boxShadowTypeNormal,
    },
  },
});
